module.exports = __webpack_public_path__ + "assets/images/oLvSQCna.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-inverse.svg
// module id = 1134
// module chunks = 0